import React from 'react';
import {FileUnknownOutlined,CommentOutlined,FileDoneOutlined} from '@ant-design/icons';
import { Menu,Divider,Layout } from 'antd';
import { Link} from "react-router-dom";

const { Sider} = Layout;

function AdminSideBar(props) {
    const id= props.props;
  return (
    <>
    <Sider width={200} collapsible 
    style={{
      overflow: 'auto',
      left: 0,
      top: 0,
      bottom: 0,
      backgroundColor:'transparent',
      height:'70vh'}}>
    <Menu style={{marginTop:'8%',minHeight:'30em',height:'100%',fontWeight:500,fontSize:'17px'}} 
      defaultSelectedKeys={[id]}>
    <Menu.Item icon={<CommentOutlined style={{ fontSize:'15px' }} />} key='1'><Link to='/AdminPanel'>Messages</Link></Menu.Item>
    <Menu.Item icon={<FileUnknownOutlined style={{ fontSize:'15px' }}/>} key='2'><Link to='/LiveRequests'>Live Requests</Link></Menu.Item>
    <Menu.Item icon={<FileDoneOutlined style={{ fontSize:'15px' }}/>} key='3'><Link to='/ApprovedClients'>Approved Clients</Link></Menu.Item>
      <Divider/>
   </Menu>
  </Sider>
  </>
  )
}

export default AdminSideBar